import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from './axios';

// initialize an empty api service that we'll inject endpoints into later as needed
export const rootApi = createApi({
  tagTypes: [
    'Applications',
    'JobApplications',
    'JobCandidates',
    'ApplicationRequests',
    'AuthContext',
    'Documents',
    'ConnectionRequests',
    'Notifications',
    'Connections',
    'Comments',
    'Job',
    'DepartmentUsers',
    'Skills',
    'Cards',
    'Subscription',
    'Invoices',
    'JobLinkRequest',
    'LinkedAgencies',
    'JobInvites',
    'JobDocuments',
    'Department',
    'User',
    'Profile',
    'CandidateProfile',
    'Clients',
    'Recruiters',
    'Account',
    'Accounts',
    'AccountSettings',
    'Checklist',
    'Stakeholders',
    'OrgInvites',
    'CompanyProfile',
    'Domains',
    'OrgContacts',
    'OrgCandidates',
    'LinkedCandidateContacts',
    'IncomingCandidateInvites',
    'OutgoingCandidateInvites',
    'IncomingCompanyInvites',
    'OutgoingCompanyInvites',
    'OrgSettings',
    'OrgBrandSettings',
    'EmailNoSyncList',
    'ProfileAvailability',
    'ProfileReferees',
    'OrgDateSettings',
    'OrgIntegrations',
    'AvailableIntegrations',
    'JobOffers',
    'Offers',
    'IntegrationFieldMap',
    'IntegrationSettings',
    'ResourceRequests',
    'JobIntegrations',
    'JobSummary',
    'CandidateJobs',
    'CandidateApplications',
    'JobActivities',
    'ApplicationActivities',
    'SystemSettings',
    'SystemTerms',
    'Placements',
    'PlacementDocuments',
    'JobPlacements',
    'GlobalOrganizations',
    'GlobalAccounts',
    'SystemDocuments',
    'ApplicationProfile',
    'Interviews',
    'ApplicationInterviews',
    'ScreeningQuestionSubmissions',
    'ParentAccounts',
    'ConnectionApplications',
    'BackgroundTasks',
    'ApplicationReferenceRequests',
    'ApplicationReferences',
    'JobBoardAvailability',
    'RejectionTemplateSettings',
    'Companies',
    'CompanyApplications',
    'CompanyJobs',
    'CompanyContacts',
    'Thread',
    'CompanyLink',
    'CompanyContactLink',
    'ContactLink',
    'ContactCompanyLink',
    'ContactDocuments',
    'CompanyDocuments',
    'EntityLabels',
    'CandidateDocuments',
    'Lists',
    'EntityLists',
    'ListItems',
    'Tasks',
    'Deals',
    'DealTasks',
    'PipelineDeals',
    'Pipelines',
    'MyPipelineDeals',
    'ApplySources',

    'DealContactLinks',
    'DealCompanyLinks',
    'DealDocuments',

    'EmailConnection',
    'MailerSettings',
    'EmailMessageTemplates',
    'EmailActivities',

    'FeatureFlags',

    'CustomFieldConfigs',
    'CustomFields',

    'Meetings',
    'MeetingContactLink',

    'Calendar',
    'OrgCalendars',
    'CalendarEvent',
    'CalendarEvents',
    'BookableEventType',
    'BookableEventTypes',
    'AvailabilityRule',
    'AvailabilityRules',

    'Reports',
    'ReportMetadata',

    'OrgPrompt',
  ],
  baseQuery: axiosBaseQuery({
    baseUrl: import.meta.env.VITE_BACKEND_URL,
  }),
  endpoints: () => ({}),
});
